import ChevronDownIcon from '@skyscanner/backpack-web/bpk-component-icon/sm/chevron-down';
import ChevronUpIcon from '@skyscanner/backpack-web/bpk-component-icon/sm/chevron-up';
import InforCircleIcon from '@skyscanner/backpack-web/bpk-component-icon/sm/information-circle';
import MenuVerticalIcon from '@skyscanner/backpack-web/bpk-component-icon/sm/menu--vertical';

import type { Configs } from '@shared/types/configs';
import type { I18nService } from '@shared/types/i18n';

import {
  enablePriceBannerWithArrowIcon,
  enablePriceBannerWithDotMenu,
  enablePriceBannerWithTrendIcon,
} from '@hotels-hotel-detail/utils/atypical-deals';
import { withI18n } from '@shared/ui/contexts/i18n';
import { withConfiguration } from '@shared/utils-frontend/contexts/ConfigurationContext';

type Props = {
  configs: Configs;
  i18n: I18nService;
  isOpen: boolean;
};
const PriceBannerExpandIcon = ({
  configs: { priceBandStyleVar },
  i18n: { translate },
  isOpen,
}: Props) => {
  if (
    enablePriceBannerWithArrowIcon(priceBandStyleVar) ||
    enablePriceBannerWithTrendIcon(priceBandStyleVar)
  ) {
    return isOpen ? (
      <ChevronUpIcon ariaLabel={translate('hd_price_range_tip')} />
    ) : (
      <ChevronDownIcon ariaLabel={translate('hd_price_range_tip')} />
    );
  }

  if (enablePriceBannerWithDotMenu(priceBandStyleVar)) {
    return <MenuVerticalIcon ariaLabel={translate('hd_price_range_tip')} />;
  }

  return <InforCircleIcon ariaLabel={translate('hd_price_range_tip')} />;
};

export default withI18n(withConfiguration(PriceBannerExpandIcon));
